import React from "react";
import Immutable from "immutable";
import { currentInputAutoSuggestType } from "../../../../common/types/search/search";

interface SelectedSuggestionsProps {
	codes: Immutable.List<string>;
	currentInput: currentInputAutoSuggestType;
	nameIndex: Immutable.Map<string, string>;
	onInputChange: (input: currentInputAutoSuggestType) => void;
}

export function SelectedSuggestions({
	codes,
	currentInput,
	nameIndex,
	onInputChange,
}: SelectedSuggestionsProps) {
	if (codes.isEmpty()) {
		return null;
	}

	const handleRemove = (choice) => {
		const index = codes.indexOf(choice);
		const updatedCodes = codes.delete(index);
		const updatedInput = currentInput.set("codes", updatedCodes);

		onInputChange(updatedInput);
	};

	const selection =
		codes &&
		codes.map((code) => {
			const label = nameIndex.get(code, code + "...");
			return (
				<li
					key={code}
					className="tag tag-removable criterion-selection"
				>
					<span>{label}</span>
					<button
						className="tag__remove"
						onClick={() => handleRemove(code)}
					>
						{"Remove " + label}
					</button>
				</li>
			);
		});

	return <ul className="criterion-selection-container">{selection}</ul>;
}
